import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class Coordinate extends AbstractProvidedClass {
    size = 10;

    constructor(provider, absX, absY) {
        super(provider);

        this.absX = absX;
        this.absY = absY;
    }

    display() {
        this.p.stroke(0);
        this.p.strokeWeight(1);
        this.p.fill(200);
        this.p.ellipse(this.currentX, this.currentY, this.size);
    }

    get currentX() {
        return this.absX * this.view.scale;
    }

    get currentY() {
        return this.absY * this.view.scale;
    }

    hovered(viewX, viewY) {
        let d = viewX || viewY
            ? this.p.dist(this.currentX, this.currentY, viewX, viewY)
            : this.p.dist(this.currentX, this.currentY, this.view.currentX, this.view.currentY);
        return d < this.size / (this.mobile ? 1.2 : 2);
    }

    drag(dx, dy) {
        this.move(dx, dy);
    }

    move(dx, dy) {
        if (dx == 0 && dy == 0) {
            return;
        }
        this.absX += dx;
        this.absY += dy;
    }

    position(absX, absY) {
        this.absX = absX;
        this.absY = absY;
    }

    diff(other) {
        return [this.absX - other.absX, this.absY - other.absY];
    }

    distanceTo(other) {
        return this.calculatePixelToDisplayDistance(this.absDistanceTo(other));
    }

    currentDistanceTo(other) {
        return this.p.dist(this.currentX, this.currentY, other.currentX, other.currentY);
    }

    absDistanceTo(other) {
        return this.p.dist(this.absX, this.absY, other.absX, other.absY);
    }

    angleTo(other) {
        return this.p.atan2(other.absY - this.absY, other.absX - this.absX);
    }

    setLengthFromCoordinate(length, other) {
        let angle = other.angleTo(this);
        this.absX = other.absX + this.p.cos(angle) * length;
        this.absY = other.absY + this.p.sin(angle) * length;
    }
}
